module.exports = __webpack_public_path__ + "img/train3.420c30bb.png";